export const blockInvalidChar = (e) =>
  [("e", "E", "+", "-", " ")].includes(e.key) && e.preventDefault();

export const blockInvalidCharNoDot = (e) =>
  [("e", "E", "+", "-", ".", " ")].includes(e.key) && e.preventDefault();
